
<div class="md:w-368 mx-auto">
  <JobPostScheduleCard
    id="schedule-type-regular"
    title="Regular sitter"
    body="Weekly, before/after school, driving"
    :shadow="false"
    class="mb-16"
  >
    <RegularScheduleIcon />
  </JobPostScheduleCard>

  <Card class="w-full md:p-24">
    <form>
      <div class="mb-32">
        <poppins-date-picker
          id="regular-schedule-datepicker"
          v-model="startDate"
          labelName="Start date"
          :minDate="minStartDate"
          :maxDate="maxStartDate"
          :status="datepickerStatus"
          :helperText="errors.startDate"
          class="mb-16"
          @input="$delete(errors, 'startDate')"
        />
        <Checkbox v-model="startDateFlexible" labelName="Start date is flexible" checkboxId="start-date-flexible" />

        <fieldset>
          <legend id="days" class="text-strong-body">Days</legend>
          <day-tokens
            v-model="days"
            class="mb-32"
            :status="daysStatus"
            :helperText="errors.days"
            @input="$delete(errors, 'days')"
          />

          <poppins-time-picker
            id="regular-schedule-start"
            v-model="startTime"
            class="mb-16"
            labelName="Start time"
            :start="startRange[0]"
            :end="startRange[1]"
            :status="startTimeStatus"
            :helperText="errors.startTime"
            @input="$delete(errors, 'startTime')"
          />
          <poppins-time-picker
            id="regular-schedule-end"
            v-model="endTime"
            class="mb-16"
            labelName="End time"
            :start="endRange[0]"
            :end="endRange[1]"
            :status="endTimeStatus"
            :helperText="errors.endTime"
            @input="$delete(errors, 'endTime')"
          />
          <div>
            <p>Duration: {{ duration }}</p>
          </div>
        </fieldset>
      </div>
      <div class="flex flex-row-reverse">
        <RouteStepperNextButton
          :stepData="reviewSection"
          :draftData="draftData"
          :validate="validate"
          @errors="errors = $event"
        />
      </div>
    </form>
  </Card>
</div>
